import { ReactElement } from 'react';
import { TrackPageViewContainer } from '../../common/containers/TrackPageViewContainer';
import { t } from '../../common/getTranslations';
import { Layout } from '../../design-system/layout/Layout';
import { SettingsContainer } from '../../domain/settings/container/SettingsContainer';
import { Settings } from '../../domain/settings/presentational/Settings';
import { CommonMobileHeaderType } from '../../header/constants';
function SettingsPage() {
  return <>
      <SettingsContainer>{props => <Settings {...props} />}</SettingsContainer>

      <TrackPageViewContainer trackObj={{
      section: '더보기',
      page: '설정',
      actionType: 'Pageview',
      actionName: '설정_화면',
      customProps: {
        user_action: 'pv'
      }
    }} />
    </>;
}
SettingsPage.getLayout = function getLayout(page: ReactElement) {
  return <Layout title={t('common_setting')} mobileLayoutConfig={{
    shouldShowHeader: true,
    headerType: CommonMobileHeaderType.ThreeDepth
  }} pcLayoutConfig={{
    shouldShowHeader: true
  }}>
      {page}
    </Layout>;
};
export default SettingsPage;